import { useQuery } from "@tanstack/react-query";

import { authClient } from "@/utils/auth-client"; // your better-auth client
import { QUERY_KEYS } from "@/utils/constants";

export function useCachedSession() {
  return useQuery({
    queryKey: [QUERY_KEYS.SESSION],
    queryFn: async () => {
      const session = await authClient.getSession();
      return session;
    },
    staleTime: 5 * 60 * 1000, // 5 min: don’t refetch until stale
    retry: false,
  });
}
